export enum ToastType {
  success,
  fail
};
